const MetricCard = ({ title, value, color = 'slate', gradient = false }) => {
    const colorMap = {
        slate: 'text-slate-800',
        emerald: 'text-emerald-600',
        blue: 'text-blue-600',
        amber: 'text-amber-600'
    };

    if (gradient) {
        return (
            <div className="col-span-2 md:col-span-1 bg-gradient-to-tr from-slate-900 to-slate-800 p-4 rounded-xl shadow-sm text-white">
                <p className="text-xs text-slate-400 font-bold uppercase tracking-wider">{title}</p>
                <p className="text-2xl font-bold text-blue-400 mt-1">AED {value.toLocaleString()}</p>
            </div>
        );
    }

    return (
        <div className="bg-white p-4 rounded-xl border border-slate-200/80 shadow-sm">
            <p className={`text-xs font-bold uppercase tracking-wider ${colorMap[color] || 'text-slate-400'}`}>{title}</p>
            <p className={`text-2xl font-bold ${colorMap[color] || 'text-slate-800'} mt-1`}>{value}</p>
        </div>
    );
};

export default MetricCard;
